import React from 'react';
import { Mail } from 'lucide-react';

interface PasswordResetButtonProps {
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  label: string;
  loadingLabel: string;
}

export const PasswordResetButton: React.FC<PasswordResetButtonProps> = ({
  onClick,
  disabled = false,
  isLoading = false,
  label,
  loadingLabel,
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="bg-brand-orange text-brand-white px-4 py-2 rounded-md hover:bg-opacity-90 transition-colors duration-200 flex items-center gap-2 disabled:opacity-50"
  >
    {isLoading ? (
      <svg
        className="animate-spin h-4 w-4 text-white"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    ) : (
      <Mail className="h-4 w-4" />
    )}
    {isLoading ? loadingLabel : label}
  </button>
);
